import React from 'react';

import {type Type, Types} from '@packages/systems/wfdl';
import TooltipTrigger from '@packages/systems/design-system/TooltipTrigger';
import {TypeTooltip} from '@packages/systems/TypeView';
import {usePlugins} from '@packages/utilities/platform';
import OneLiner from '@packages/systems/design-system/OneLiner';

export default function OnelineLabel({
  children,
  path,
  type,
}: {
  children: string;
  path?: string;
  type?: Type | null;
}) {
  const plugins = usePlugins();
  if (type) {
    const icon = Types.getIcon(type, plugins);
    return (
      <TypeTooltip icon={icon} label={children} path={path} type={type}>
        <OneLiner>{children}</OneLiner>
      </TypeTooltip>
    );
  }
  return (
    <TooltipTrigger content={path || children} alternate>
      <OneLiner>{children}</OneLiner>
    </TooltipTrigger>
  );
}
